import {Permissions} from '@/constants/app.constant'
import {APP_PREFIX_PATH} from '@/constants/route.constant'
import {NAV_ITEM_TYPE_ITEM, NAV_ITEM_TYPE_TITLE} from '@/constants/navigation.constant'

const supportNavigationConfig = [
    {
        key: 'supportMenu',
        path: '',
        title: 'پشتیبانی',
        translateKey: '',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.support.value],
        subMenu: [
            {
                key: 'poll',
                path: `${APP_PREFIX_PATH}/poll`,
                title: 'نظرسنجی',
                translateKey: 'نظرسنجی',
                icon: 'FaPoll',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.support.polls.value],
                subMenu: [
                    {
                        key: 'polls',
                        path: `${APP_PREFIX_PATH}/polls`,
                        title: 'نظرسنجی‌ها',
                        translateKey: 'نظرسنجی‌ها',
                        icon: 'FaPoll',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.support.polls.read],
                        subMenu: [],
                    },
                    {
                        key: 'polls/feedbacks',
                        path: `${APP_PREFIX_PATH}/polls/feedbacks`,
                        title: 'بازخوردهای نظرسنجی‌ها',
                        translateKey: 'بازخوردهای نظرسنجی‌ها',
                        icon: 'MdFeedback',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.support.polls.value],
                        subMenu: [],
                    }
                ],
            },
            {
                key: 'reports',
                path: `${APP_PREFIX_PATH}/reports`,
                title: 'گزارشات',
                translateKey: 'گزارشات',
                icon: 'MdOutlineReport',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.support.reports.value],
                subMenu: [],
            },
            {
                key: 'tickets',
                path: `${APP_PREFIX_PATH}/tickets`,
                title: 'تیکت‌ها',
                translateKey: 'تیکت‌ها',
                icon: 'MdOutlineSupportAgent',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.support.tickets.value],
                subMenu: [],
            },
            {
                key: 'faqs',
                path: `${APP_PREFIX_PATH}/faqs`,
                title: 'سوالات متداول',
                translateKey: 'سوالات متداول',
                icon: 'AiOutlineQuestionCircle',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.support.faqs.value],
                subMenu: [],
            },
        ],
    },
]

export default supportNavigationConfig
